export default __webpack_public_path__ + "static/media/56t.2887b31e.jpg";